import { Dimensions } from 'react-native';
import { LAYOUTS, OpenNewTabTargetType, SCREEN_SIZE, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { goBack } from './actions';
import { DeepLinks } from '../../../configs/config';
import { getScreenType } from '../../../configs/platfom-utils';
import { getContactNumberForCall, getContactNumberForWhatsapp, } from '../../../configs/uri-config-utils';
import SharedPropsService from '../../../SharedPropsService';
import { addSupportAmplitudeEvent, isIframe } from "../../../configs/utils";
import { AMPLITUDE_EVENT } from "../../../configs/constants";
export const template = (whatsappNumber, callNumber, emailId, openNewTab, instrumentTrack, isFromPhonePe, isFromJupiter, showCall, showEmail, showWA, showSupportPhoneNumber, height) => {
    return {
        layout: {
            id: ROUTE.CONTACT_US,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                { id: "contactUsPageDC", type: WIDGET.CONTACT_US_PAGE }
            ],
        },
        datastore: {
            contactUsPageDC: {
                backAction: {
                    type: ACTION.BACK_BUTTON,
                    payload: {
                        id: 'bt_contactUs_goBack'
                    },
                    routeId: ROUTE.CONTACT_US
                },
                height: height,
                isFromJupiter: isFromJupiter,
                callNumber: callNumber,
                whatsappNumber: whatsappNumber,
                emailId: emailId,
                showWA: showWA,
                showCall: showCall,
                showEmail: showEmail,
                showSupportPhoneNumber: showSupportPhoneNumber,
                openWhatsAppAction: () => {
                    addSupportAmplitudeEvent(instrumentTrack, AMPLITUDE_EVENT.CONTACT_VIA_WA_BUTTON_CLICKED);
                    const screenType = getScreenType(Dimensions.get('window').width);
                    if (isFromPhonePe) {
                        openNewTab('whatsapp://send?phone=+919611749097&text=Hi', OpenNewTabTargetType.parent);
                    }
                    else {
                        if (isIframe()) {
                            openNewTab(DeepLinks.WHATSAPP + whatsappNumber, OpenNewTabTargetType.blank);
                        }
                        else if (screenType === SCREEN_SIZE.X_SMALL ||
                            screenType === SCREEN_SIZE.SMALL) {
                            openNewTab(DeepLinks.MOBILE_WHATSAPP + whatsappNumber, OpenNewTabTargetType.parent);
                        }
                        else {
                            openNewTab(DeepLinks.WHATSAPP + whatsappNumber, OpenNewTabTargetType.blank);
                        }
                    }
                },
                openCallAction: () => {
                    addSupportAmplitudeEvent(instrumentTrack, AMPLITUDE_EVENT.CONTACT_VIA_CALL_BUTTON_CLICKED);
                    openNewTab(DeepLinks.CALL + callNumber, OpenNewTabTargetType.parent);
                },
                openEmailAction: () => {
                    addSupportAmplitudeEvent(instrumentTrack, AMPLITUDE_EVENT.CONTACT_VIA_EMAIL_BUTTON_CLICKED);
                    openNewTab(DeepLinks.MAILTO + emailId, OpenNewTabTargetType.parent);
                },
            },
        },
    };
};
export const contactUsMF = {
    onLoad: async ({ openNewTab, instrumentTrack, getHeight }) => {
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
        const callData = await SharedPropsService.getCallData();
        const emailData = await SharedPropsService.getEmailData();
        const showCall = await SharedPropsService.getShowCall();
        const showSupportPhoneNumber = await SharedPropsService.getSupportPhoneNumber();
        const showEmail = await SharedPropsService.getShowEmail();
        const showWA = await SharedPropsService.getShowWA();
        const waData = await SharedPropsService.getWAData();
        const url = await SharedPropsService.getURL();
        const whatsappDeepLinkDesktop = waData ? waData : await getContactNumberForWhatsapp(url);
        const callDeepLink = callData ? callData : await getContactNumberForCall(url);
        const emailId = emailData ? emailData : isFromJupiter ? 'support@jupiter.money' : 'support@voltmoney.in';
        let isFromPhonePe = await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */;
        addSupportAmplitudeEvent(instrumentTrack, AMPLITUDE_EVENT.CONTACT_SUPPORT_BUTTON_CLICKED);
        return Promise.resolve(template(whatsappDeepLinkDesktop, callDeepLink, emailId, openNewTab, instrumentTrack, isFromPhonePe, isFromJupiter, showCall, showEmail, showWA, showSupportPhoneNumber, getHeight()));
    },
    actions: {
        [ACTION.BACK_BUTTON]: goBack,
    },
    bgColor: '#FFFFFF',
};
